export default "/images/life-buoy.svg?f2aeaeaf64fbc44f283112d92dbfbfdb";